<template>
  <div
    v-if="currentCluster.length > 0"
    :class="{ 'theme-dark': !nightMode, content: nightMode }"
    class="mt-10"
  >
    <div class="p-4 grid grid-cols-1 lg:grid-cols gap-2" v-if="showTable">
      <div class="flex flex-cols items-center justify-between">
        <div class="cluster-title text-sm sm:text-base">
          {{ $t("alarms_table_title") }}
        </div>
        <button
          class="cluster-button cluster-gray px-4 py-2 rounded-sm text-xs sm:text-base"
          :class="{
            'cluster-light': nightMode,
          }"
          @click="showSensorModal()"
        >
          + {{ $t("alarms_table_button") }}
        </button>
      </div>
      <div v-if="alarmList.length > 0" class="cluster">
        <div class="block border border-white">
          <div
            class="
              grid grid-cols-4
              pl-4
              py-1
              text-xs
              lg:grid-cols-4
              sm:text-base
            "
            :class="{
              'cluster-gray': !nightMode,
              'cluster-light': nightMode,
            }"
          >
            <div class="title">{{ $t("alarms_table_alias") }}</div>
            <div class="title">{{ $t("alarms_table_sensor") }}</div>
            <div class="title mr-1 break-words col-span-2 lg:col-span-1">{{ $t("alarms_table_notification") }}</div>
            <div class="title hidden lg:block">{{ $t("alarms_table_delete") }}</div>
          </div>
          <div
            class="
              pl-4
              py-1
              items-center
              text-xs
              grid grid-cols-4
              lg:grid-cols-4
              sm:text-base
            "
            v-for="(item, index) in alarmList"
            :key="item.id"
            :class="{
              'cluster-gray': index % 2 !== 0,
              'cluster-light': nightMode && index % 2 !== 0,
            }"
          >
            <div>
              <div>{{ item.solarHub.name }}</div>
            </div>
            <div>
              <div v-if="item.sensor">{{ item.sensor.name }}</div>
            </div>
            <div>
              <a class="link-channel" href="#">{{ item.channel }}</a>
            </div>
            <div class="flex items-center justify-end pr-4 lg:pr-0 lg:justify-start">
              <button @click="deleteSensor(index)">
                <div class="w-6">
                  <img :src="require(`@/assets/icon-delete.png`)" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>{{$t('alarms_message_empty')}}</div>
    </div>
    <div v-else class="text-center text-2xl my-32 sm:my-48">{{$t('reports_message_error_noalarms')}}</div>

    <div class="ml-4 flex flex-cols flex-wrap justify-start" v-if="solarHubList">
      <div
        class="text-center text-base mr-4 lg:text-lg"
        v-for="(item, index) in solarHubList"
        :key="index"
      >
        <div class="title py-2">{{ item.name }}</div>
        <div
          class="
            box
            grid grid-rows-3
            items-center
            border
            cluster-gray-border
            lg:px-2
            lg:py-2
          "
        >
          <div class="py-2 mx-4">
            {{ $t("days_maintenance") }}
          </div>
          <div class="w-10 mx-auto">
            <img
              class="w-full"
              :src="require(`@/assets/icon-maintenance.png`)"
            />
          </div>
          <div class="text-3xl">{{ item.day_m }}</div>
        </div>
      </div>
    </div>
    <sensor-modal
      v-if="sensors.length > 0"
      @addAlarmToTable="addAlarmToTable"
      :sensors="sensors"
      :nightMode="nightMode"
      :selectedHub="selectedHub"
    ></sensor-modal>
  </div>
</template>
<script>
/**
 * Vista de Alarmas, contiene una tabla con un listado de alarmas, donde se puede crear una alarma nueva y también muestra los días de mantenimiento de cada solarhub.
 */
import SensorModal from "../components/modals/SensorModal.vue";
import { getAlarms, deleteAlarm } from "@/utils/AlarmService.js";
import { getListSolarHubs } from "@/utils/SolarHubService.js";
import { mapState } from "vuex";

export default {
  /**
  * Para esta vista importamos el componente SensorModal, para crear una alarma sobre ese sensor y seleccionar el tipo de notificación.
  */
  components: { SensorModal },
  props: ["nightMode", "selectedHub"],
  data() {
    return {
      solarHubList: [],
      alarmList: [],
      sensors: [],
      showTable: true
    };
  },
    /**
    * Obtenemos la lista de solarhubs para poder obtener los valores de días de mantenimiento
    * Obtenemos la lista de alarmas para mostrar en la tabla
    */
  async beforeMount() {
      this.solarHubList = await this.getSolarHubsData();
      this.alarmList = await this.getAlarmsbySolarHub();
  },
  methods: {
    /**
    * Mostramos el modal para añadir una alarma
    */
    showSensorModal() {
      this.$modal.show("sensor-modal");
    },
    /**
    * Método que obtiene la lista de las alarmas de un solarhub
    */
    async addAlarmToTable() {
      this.alarmList = await this.getAlarmsbySolarHub();
    },
    /**
    * Método que elimina una alarma de la tabla. 
    */
    deleteSensor(index) {
      deleteAlarm(
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub].id,
        this.alarmList[index].id
      );
      this.alarmList = this.alarmList.filter(alarm => {
        return alarm.id !== this.alarmList[index].id;
      });
    },
    /**
    * Método que obtiene la lista de solarhubs para después devolver una lista de mantenimiento.
    */
    async getSolarHubsData() {
      let solarHubList = await getListSolarHubs(this.currentCluster[0].id);
      let filteredSolarHubList = solarHubList.map((s)=> s.sensors.filter(sn=>sn.influxId !== "SoC" &&  sn.influxId !== "iBATx100" && sn.influxId !== "vLedMPPTx100"))
      this.showTable = filteredSolarHubList[this.selectedHub].length > 0;
      this.sensors = solarHubList;
      let maintenanceList = this.getMaintenanceData(solarHubList)
      return maintenanceList;
    },
    /**
    * Método devuelve una lista de mantenimiento a partir de una lista de solarhubs.
    */
    getMaintenanceData(solarHubList){
      let currentDay = new Date().getTime();
      return solarHubList.map(s => {
        let dMaintenance = new Date(s.maintenanceDate).getTime();
        let diff_time = dMaintenance - currentDay;
        let diff_days = diff_time / (1000 * 3600 * 24);
        return { name: s.name, day_m: diff_days.toFixed(0) };
      });
    },
        /**
    * Método que devuelve una lista de alarmas de un solarhub
    */
    async getAlarmsbySolarHub() {
      const alarmListData = await getAlarms(this.currentCluster[0].id);
      let alarmListFilterById = alarmListData.filter(
        a =>
          a.solarHub.id == this.currentCluster[0].solarHubs[this.selectedHub].id
      );
      return alarmListFilterById;
    },
    /**
    * Método para actualizar la lista de solarhubs y la lista de alarmas de el solarhub seleccionado.
    */
    async updateData() {
      this.solarHubList = await this.getSolarHubsData();
      this.alarmList = await this.getAlarmsbySolarHub();

    }
  },
  computed: {
    ...mapState("clusters", ["currentCluster"])
  },
  watch: {
    /**
    * Cuando hay un cambio de cluster o de solarhub, ejecuta el método updateData
    */
    currentCluster: function() {
      this.updateData();
    },
    selectedHub: function() {
      this.updateData();
    }
  }
};
</script>
<style scoped>
.content {
  background-color: white;
}
.cluster-light {
  background-color: #cccccc;
}
.cluster-gray {
  background-color: #2d2d2d;
  color:white;
}
.cluster-gray-border {
  border-color: #cccccc;
}
.link-channel {
  color: #fbb03b;
}
</style>